export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return '?'
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}

export function fullName(firstname: string, lastname: string, fallback = ''): string {
  const n = `${firstname} ${lastname}`.trim()
  return n || fallback
}

const ROLE_LABELS: Record<string, string> = {
  admin: 'System Administrator',
  ops: 'Treasury / Payment Ops',
  auditor: 'Auditor (read-only)',
}

export function roleLabel(role: string): string {
  return ROLE_LABELS[role] ?? role
}

/** "3s ago", "4m ago", "2h ago" from an ISO timestamp (or "—" if absent). */
export function timeAgo(iso?: string | null): string {
  if (!iso) return '—'
  const then = new Date(iso).getTime()
  if (Number.isNaN(then)) return '—'
  const s = Math.max(0, Math.floor((Date.now() - then) / 1000))
  if (s < 60) return `${s}s ago`
  const m = Math.floor(s / 60)
  if (m < 60) return `${m}m ago`
  const h = Math.floor(m / 60)
  if (h < 24) return `${h}h ago`
  const d = Math.floor(h / 24)
  return `${d}d ago`
}

/** Capitalise a backend status slug for display ("delivered" → "Delivered"). */
export function titleCase(s?: string | null): string {
  if (!s) return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

/** Format a decimal-string amount as money ("48400.0000" → "KES 48,400.00"); "—" when absent. */
export function fmtMoney(v?: string | null, currency = 'KES'): string {
  if (v === undefined || v === null || v === '') return '—'
  const n = Number(v)
  if (Number.isNaN(n)) return v
  return `${currency} ${n.toLocaleString('en-KE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
}

export function fmtDateTime(iso?: string | null): string {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  return d.toLocaleString('en-GB', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })
}
